/*
 * Gekoppelde-producten swatches.
 * Vangt klikken op swatch-links op en vervangt het <product-info> element via de
 * Section Rendering API, zodat het aanvoelt als echte varianten terwijl elk product
 * een eigen pagina/URL houdt. Zonder JS (of bij fouten) volgt gewone navigatie.
 */
(function () {
  'use strict';

  if (window.__rbLinkedSwatchesInit) return;
  window.__rbLinkedSwatchesInit = true;

  function reinitApps(scope) {
    // Best-effort her-initialisatie van app-widgets na het verwisselen van de content.
    try {
      if (window.AirReviews && typeof window.AirReviews.init === 'function') {
        window.AirReviews.init();
      }
    } catch (e) { /* noop */ }
    // Generiek signaal waar apps/thema's op kunnen luisteren.
    document.dispatchEvent(
      new CustomEvent('rb:product:swapped', { detail: { scope: scope } })
    );
  }

  function swap(url, sectionId, wrap) {
    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
    var targetId = 'MainProduct-' + sectionId;

    if (wrap) wrap.classList.add('is-loading');

    fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newEl = doc.getElementById(targetId);
        var curEl = document.getElementById(targetId);
        if (!newEl || !curEl) {
          window.location.assign(url);
          return;
        }

        curEl.replaceWith(newEl); // <product-info> is een custom element -> her-init vanzelf

        // Documenttitel meenemen indien aanwezig.
        if (doc.title) document.title = doc.title;

        // URL bijwerken zonder herladen.
        window.history.pushState({ rbSwatch: true }, '', url);

        reinitApps(newEl);
      })
      .catch(function () {
        window.location.assign(url);
      });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[data-rb-swatch]');
    if (!link) return;

    // Modifier-klikken / nieuwe tab met rust laten.
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
      return;
    }

    var wrap = link.closest('[data-rb-swatches]');
    var sectionId = wrap && wrap.getAttribute('data-section-id');
    if (!sectionId) return; // geen sectie-id bekend -> laat normale navigatie gebeuren

    e.preventDefault();
    swap(link.href, sectionId, wrap);
  });

  // Terug/vooruit-knop: herlaad de juiste productpagina.
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.rbSwatch) {
      window.location.reload();
    }
  });
})();
